import React from 'react'

const SvgThermometerOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 5v10.354a4 4 0 11-6 0V5a3 3 0 016 0zM9.5 5a.5.5 0 00-1 0v12.134a1 1 0 101 0V5zM16 10a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 100-2 1 1 0 000 2z'
    />
  </svg>
)

export default SvgThermometerOutline
